import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

const AdminTOSProtectedRoute = ({ children }) => {
    const [isAllowed, setIsAllowed] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const response = await api.get('/api/user');
                const userRole = (response.data.role || '').toLowerCase().replace(' ', '_');
                setIsAllowed(userRole === 'super_admin' || userRole === 'admin');
            } catch (error) {
                setIsAllowed(false);
            } finally {
                setLoading(false);
            }
        };

        checkAccess();
    }, []);

    if (loading) {
        return <div style={{ color: 'white', padding: '20px' }}>Loading...</div>;
    }

    return isAllowed ? children : <Navigate to="/home" />;
};

export default AdminTOSProtectedRoute;
